import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
// import {TextField}  from '@material-ui/core/TextField';
import Recaptcha from 'react-recaptcha'
import RaisedButton from 'material-ui/RaisedButton';
import s from '../../services/allservices.jsx'
import '../../stylesheet/contactus.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import services from '../../services/allservices.jsx'
import {
    withRouter
} from 'react-router-dom';
// import kapcha from '../../images/Kaptcha.jpg'
import LoaderSmall from "../loader/loadersmall.jsx"
import { getClientId, getClientSecret,buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};


var callback = function () {

};



// specifying verify callback function


// specifying verify callback function
// var verifyCallback = function (response) {

//     let state = {
//         "g-recaptcha-response": response
//     }

//     fetch(s.capcha, {
//         method: "POST",
//         headers: {
//             'content-type': 'application/json'
//         },
//         body: { "g-recaptcha-response": response }
//     })
//         .then(res => {

//         })
// };

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            capcha: '',
            response: "",
            firstName: "",
            lastName: "",
            comments: "",
            emailId: "",
            correctphone: true,
            correctcomm: true,
            subject: 1,
            disabled: true,
            correctEmail: true,
            mobileNumber: "",
            cardDetailsId: ""

        }
        // this.handleCapcha = this.handleCapcha.bind(this)
        this.handleMobile = this.handleMobile.bind(this)
    }
    handleSelect = (event, index, value) => this.setState({ subject: value });



    handleMobile() {
        const { mobileNumber } = this.state
        // let arr = []
        let no = mobileNumber.split('')
        no.unshift('0')

        let num = no.join('')

        this.setState({
            mobileNumber: num
        })

    }



    // formatNumber(cardno) {
    //     // return cardno.toString().replace(/(\d{4})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
    //     let arr = []
    //     let no = cardno.split('')
    //     for(let i = 1; i<=no.length; i++){
    //         arr.push(no[i-1])
    //         if((i%4) === 0){ arr.push(' ') }
    //     }
    //     return arr.join('')ength
    //   }



    handleChange = (e, value) => {
        const { name } = e.target
        this.setState({ [name]: e.target.value })

        if (e.target.name === "firstName" || e.target.name === "lastName" || e.target.name === "comments" || e.target.name === "emailId" || e.target.name === "subject" || e.target.name === "mobileNumber") {

            if (e.target.name === "emailId") {
                // eslint-disable-next-line
                if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                    this.setState({
                        correctEmail: true,
                        emailId: value,
                        disabled: false,
                    })
                } else {
                    this.setState({
                        correctEmail: false,
                        disabled: true,
                    })
                }
            }

            if (e.target.name === "mobileNumber") {
                if (/^\d{3,20}$/.test(e.target.value)) {

                    this.setState({
                        correctphone: true,
                        mobileNumber: value,
                        disabled: false,
                    })
                } else {
                    this.setState({
                        correctphone: false,
                        disabled: true,
                    })
                }
            }

            this.setState({
                [e.target.name]: e.target.value
            }, () => {

                const { firstName, lastName, comments, subject, emailId, mobileNumber, response } = this.state

                if (firstName !== "" && lastName !== "" && comments !== "" && subject !== "" && emailId !== "" && mobileNumber !== "" && response !== "") {

                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }

    verifyCallback = response => {
        this.setState({
            response: response

        }, () => {
            const { firstName, lastName, comments, subject, emailId, mobileNumber, } = this.state

            if (firstName !== "" && lastName !== "" && comments !== "" && subject !== "" && emailId !== "" && mobileNumber !== "" && response !== "") {

                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        })
    }
    expiredCallback = response => {
        this.setState({
            disabled: true
        })

    }

    handleSubmit = () => {
        const { response, correctEmail, correctphone } = this.state
        if (correctEmail === false) {
            this.setState({
                correctEmail: false
            })
        }
        else if (correctphone === false) {
            this.setState({
                correctphone: false
            })
        }
        else {

            let _this = this
            if (response !== '') {
                const state = {
                    firstName: _this.state.firstName,
                    lastName: _this.state.lastName,
                    comments: _this.state.comments,
                    emailId: _this.state.emailId,
                    subject: _this.state.subject,
                    mobileNumber: _this.state.mobileNumber,
                    cardDetailsId: " "
                }


                this.setState({
                    loader: true,
                    disabled: true,
                })
                let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
                let gid = getClientId();
                let traceId = getClientId()
                fetch(plink + s.contact_us + "/?g-recaptcha-response=" + response, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',                     
                        'clientId': gid,
                        'clientSecret': getClientSecret(gid,this.state.firstName),
                        'X-Trace-Id': traceId,
                        'X-KlickEx-Client':buildClientHeader(),

                    }),
                    body: JSON.stringify(state)
                })
                    .then(res => {
                        if (res.status === 200 || res.status === 201) {
                            toast.success(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false
                            })
                            setTimeout(function () {
                                window.location.reload(1);
                            }, 3000);

                        } else {

                            toast.error(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })
            }
        }
    }

    render() {
        const { correctEmail, correctphone } = this.state

        return (

            <div className="col-sm-12">
                {/* <div id="xclamation-agent-bot"></div> */}
                <div className="row" style={{ padding: "0 15px" }}>
                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    />

                    <div className="col-sm-12 ">
                        <div className="row" >
                            <div className="col-sm-12 bg-white" style={{ padding: "15px 20px" }}>
                                <div className="row">

                                    <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                        <h4 className='logmainheading mainheading'>
                                            Contact Us
                                        </h4>
                                    </div>
                                </div>
                                <div className="row input-group" >
                                    <div className=" col-sm-5">
                                        <div className="row">
                                            {/* <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-12" >
                                                <TextField
                                                    hintText="Type Your First Name"
                                                    floatingLabelText="First Name"
                                                    type="text"
                                                    name="firstName"
                                                    autoComplete='none'
                                                    maxLength="30"
                                                    className="input-width required simsfont"
                                                    onChange={this.handleChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle} />

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-sm-5">
                                        <div className="row">
                                            {/* <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-12" >
                                                <TextField
                                                    hintText="Type Your Last Name"
                                                    floatingLabelText="Last Name"
                                                    type="text"
                                                    htmlFor="choose"
                                                    name="lastName"
                                                    maxLength="30"
                                                    // autoComplete='none'
                                                    autoComplete='off'
                                                    className="input-width required simsfont"
                                                    onChange={this.handleChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row input-group" >
                                    <div className=" col-sm-5">
                                        <div className="row">
                                            {/* <div className="col-sm-2 conemailinput" >
                                                <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-12" >
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="Email"
                                                    type="text"
                                                    name="emailId"
                                                    autoComplete='none'
                                                    maxLength="50"
                                                    className="input-width required simsfont"
                                                    onBlur={this.handleChange}

                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    // errorText={correctEmail ? null : "Not a valid email"}
                                                    errorText={correctEmail ? null : "Invalid Email"}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-sm-6">
                                        <div className="row input-group" >
                                            {/* <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-thumb-tack" aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-11">
                                                <SelectField
                                                    floatingLabelText="Select Subject"
                                                    value={this.state.subject}
                                                    className="input-width required simsfont"
                                                    onChange={this.handleSelect}
                                                    autoComplete='none'
                                                    name="subject"
                                                >
                                                    <MenuItem className="menuitem" value={1} primaryText="Card Issues And Questions" />
                                                    <MenuItem className="menuitem" value={3} primaryText="PIN Reset" />
                                                    <MenuItem className="menuitem" value={4} primaryText="Unlock Card" />
                                                    <MenuItem className="menuitem" value={5} primaryText="Login Issue" />
                                                    <MenuItem className="menuitem" value={6} primaryText="Activation Issue" />
                                                    <MenuItem className="menuitem" value={2} primaryText="Others" />
                                                </SelectField>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row input-group" >
                                        <div className="col-sm-5">

                                            <div className="row">
                                                {/* <div className="col-sm-2 conemailinput" >
                                                    <i className="fa fa-mobile text-dark " aria-hidden="true"></i>
                                                </div> */}
                                                <div className="col-sm-12" >

                                                    <TextField
                                                        hintText="Enter Mobile Number"
                                                        floatingLabelText="Mobile Number"
                                                        type="text"
                                                        maxLength="20"
                                                        name="mobileNumber"
                                                        onChange={this.handleChange.bind(this)}
                                                        // onInput={(e) => {
                                                        //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                        // }}
                                                        autoComplete='none'
                                                        className="input-width required simsfont"
                                                        value={this.state.mobileNumber}

                                                        // onBlur={this.handleMobile}
                                                        // onFocus={this.removephone}
                                                        underlineStyle={styles.underline}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        inputStyle={styles.inputStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        floatingLabelStyle={styles.floatingLabelStyle}
                                                        errorText={correctphone ? null : "Invalid Mobile Number"} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="row">
                                                {/* <div className="col-sm-2 input-icon" >
                                                    <i className="fa fa-comment text-dark " aria-hidden="true"></i>
                                                </div> */}
                                                <div className="col-sm-12" >
                                                    <TextField
                                                        hintText="Write Your Comment"
                                                        floatingLabelText="Comments"
                                                        multiLine={true}
                                                        className="input-width required simsfont"
                                                        name="comments"
                                                        autoComplete='none'
                                                        rows={1}

                                                        onChange={this.handleChange}
                                                        maxLength="1000"
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="row input-group" >

                                        <div className="col-sm-4">
                                            <div className="row">
                                                <div className="col-sm-12 text-center margin-capcha">
                                                    <Recaptcha
                                                        sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                        render="explicit"
                                                        verifyCallback={this.verifyCallback}
                                                        expiredCallback={this.expiredCallback}
                                                        onloadCallback={callback}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="offset-sm-2 col-sm-4">
                                            <div className="row">

                                                
                                                
                                            </div>
                                         
                                        </div>
                                    </div>
                                    <div className="row input-group pb-5" >

                                        <div className="col-sm-4">
                                            <div className="">
                                            
                                                <RaisedButton
                                                    label="Submit"
                                                    backgroundColor="#FFCE39"
                                                    labelColor="#115876"
                                                    id="submit"
                                                    className="btn-std"
                                                    disabled={this.state.disabled}
                                                    onClick={this.handleSubmit}
                                                    style={{ marginTop: "48px", borderRadius: "50"}}
                                                />
                                            </div>
                                        </div>

                                        <div className="offset-sm-2 col-sm-4">
                                            <div className="row">

                                                
                                            </div>
                                            {
                                                this.state.loader === true &&
                                                <div className="col-sm-1" style={{ marginTop: "20px", width: "30% !mportant" }} >
                                                    <LoaderSmall />
                                                </div>}
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}
export default withRouter(ContactUs);



// WEBPACK FOOTER //
// ./src/components/contactus/contactus.jsx